/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiPersonDetailReviewsListPetType =
  (typeof ApiPersonDetailReviewsListPetType)[keyof typeof ApiPersonDetailReviewsListPetType];

export const ApiPersonDetailReviewsListPetType = {
  dog: 'dog',
  cat: 'cat',
  puppy: 'puppy',
} as const;
